import z from "zod";

export const AuditMetaSchema = z.object({
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
  isArchived: z.boolean().optional(),
  deletedBy: z.string().optional(),
  deletedAt: z.string().optional(),
});
export type AuditMeta = z.infer<typeof AuditMetaSchema>;
